import { lazy, type ReactElement } from 'react'

// Public page — reached by the user's browser when Ubble redirects after the
// verification flow finishes. No auth is required: the webhook path (server
// to server) is what actually updates the verification state in our DB.
export const LazyIdentityVerificationReturn = lazy(() =>
  import('../pages/IdentityVerificationReturn/IdentityVerificationReturn').then((module) => ({
    default: module.IdentityVerificationReturn,
  })),
)

export const IdentityVerificationReturnRoute = (): ReactElement => {
  return <LazyIdentityVerificationReturn />
}
